import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Widget de CRCs Vencidos (Hub admin + supervisor_general_pipas).
 * Muestra cuenta + lista clickeable. Si vacío, no aparece.
 */
export default function WidgetCrcsVencidos() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [expand, setExpand] = useState(false);

  const visible = user && ["admin", "supervisor_general_pipas"].includes(user.rol);

  useEffect(() => {
    if (!visible) return;
    axios.get(`${API}/admin/crcs-vencidos`).then(r => setData(r.data)).catch(() => setData({ total: 0, items: [] }));
  }, [visible]);

  if (!visible || !data || data.total === 0) return null;

  return (
    <div className="rounded-xl border-2 border-red-300 bg-red-50 p-4 mb-4" data-testid="widget-crcs-vencidos">
      <div className="flex items-center justify-between gap-2 cursor-pointer" onClick={() => setExpand(v => !v)}>
        <div className="flex items-center gap-3">
          <div className="rounded-full bg-red-600 text-white w-10 h-10 grid place-items-center flex-shrink-0">
            <i className="fa-solid fa-bell"/>
          </div>
          <div>
            <div className="font-bold text-red-900" data-testid="widget-venc-count">
              {data.total} CRC{data.total === 1 ? "" : "s"} VENCIDO{data.total === 1 ? "" : "S"}
            </div>
            <div className="text-xs text-red-700">Con fecha de atención pasada · sin cerrar</div>
          </div>
        </div>
        <button className="btn-ghost text-sm" data-testid="widget-venc-toggle">
          <i className={`fa-solid ${expand ? "fa-chevron-up" : "fa-chevron-down"}`}/>
        </button>
      </div>

      {expand && (
        <ul className="mt-3 space-y-1.5" data-testid="widget-venc-list">
          {data.items.slice(0, 10).map(it => (
            <li key={it.id}
                className="bg-white rounded-md p-2.5 border border-red-200 text-sm cursor-pointer hover:bg-red-50"
                onClick={() => navigate("/solicitudes-pipa")}
                data-testid={`widget-venc-item-${it.folio}`}>
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <span className="mono font-bold text-red-800">{it.folio}</span>
                <span className="text-xs bg-red-100 text-red-800 px-1.5 py-0.5 rounded font-bold">
                  {it.dias_vencido} día{it.dias_vencido === 1 ? "" : "s"} vencido
                </span>
              </div>
              <div className="text-xs text-slate-700 mt-1 truncate">{it.direccion || "Sin dirección"}</div>
              <div className="text-[11px] text-slate-500 mt-0.5">
                Pipa <strong>{it.pipa_asignada_id || "—"}</strong>
                {it.chofer_titular_nombre && <> · {it.chofer_titular_nombre}</>}
                {it.zona && <> · {it.zona}</>}
                {it.urgencia && <> · {it.urgencia}</>}
              </div>
            </li>
          ))}
          {data.items.length > 10 && (
            <li className="text-xs text-center text-slate-500 pt-1">… {data.items.length - 10} más</li>
          )}
        </ul>
      )}
    </div>
  );
}
